import { app, authentication } from '@microsoft/teams-js';
import { useEffect, useState } from 'react';
import ClioSetup from './clio-setup';

const ClioCallback = () => {
    const [isTeamsPopUp, setIsTeamsPopUp] = useState<boolean>(false);

    useEffect(() => {
        if (!!localStorage.getItem("teamsUserEmail")) {
            app.initialize().then((context) => {
                app.notifySuccess();
                setIsTeamsPopUp(true)
            });
            app.getContext().then((context) => {
                authentication.notifySuccess("true");
                setIsTeamsPopUp(false)
            }).catch(error => {
                authentication.notifyFailure(error.message || "An error occurred");
            })
        }
        else {
            setIsTeamsPopUp(false)
        }
    }, [window.location, localStorage.getItem("teamsUserEmail")])

    return (
        <>
            {isTeamsPopUp ? <div className='d-flex flex-direction w-p-60 h-p-80 justify-center align-center m-auto login-background br-5 bg-color-secondary'>
                <div className='h1-semibold d-flex justify-center h-p-20'>
                    Getting things ready...!
                </div>
            </div> : <ClioSetup />
            }
        </>
    )
}

export default (ClioCallback);
